import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LoadChartScheduleReportComponent } from 'src/app/popup/loadchart-schedulereport/loadchart-schedulereport.component';
import { AdminService } from 'src/app/Service/admin.service';
import { AuthService } from 'src/app/service/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { FlowMeterService } from 'src/app/service/flowmeter.service';
import { GSMConfigurationService } from 'src/app/Service/gsmconfiguration.service';
import { GenericValidator } from 'src/app/validation/general-validation';

@Component({
  selector: 'app-load-chart',
  templateUrl: './load-chart.component.html',
  styleUrls: ['./load-chart.component.css'],
})
export class LoadChartComponent implements OnInit {
  IsforBatchData: string = ''
  loadChartForm: FormGroup;
  totalconsumptionError: any = '';
  totalconsumptionsuccess: any = '';
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  windowheight: any;
  divHeight: number;
  tableHeight: number;
  SiteList: any = [];
  errorMsg: any;
  PanelList: any[];
  DeviceList: any[];
  RegisterData: any[] = [];
  SiteId: string = '';
  PanelId: string = '';
  CompanyCode: any;
  UserId: any;
  RoleName: any;
  CompanyIdforUC: any;
  TotalConsumptionReportData: any[] = [];
  tableHeaders: string[] = [];
  GraphDetailList: any;
  ReportDetailList: any;
  TagId_List: any;
  labelname_List: any;
  decimalList: any = [];
  columns: any = [];
  displaystartdate: boolean;
  searchControl = new FormControl('');
  dataSource: any;
  getallmeterlist: any[] = []
  displayMessage: { [key: string]: string } = {};
  private genericValidator: GenericValidator;
  private validationMessages: { [key: string]: { [key: string]: string } };

  constructor(
    private adminService: AdminService,
    private formBuilder: FormBuilder,
    private commonservice: CommonService,
    private GSMConfigService: GSMConfigurationService,
    private flowmeterservice: FlowMeterService,
    public dialog: MatDialog,
    private authService: AuthService
  ) {
    this.CompanyCode = localStorage.getItem('CompanyCode');
    this.UserId = +localStorage.getItem('UserId');
    this.RoleName = localStorage.getItem('RoleName');
    this.ResizeHeight();
    localStorage.setItem('IsFromAddCompany', 'N');
    this.RoleName = localStorage.getItem('RoleName');
    this.CompanyIdforUC = +localStorage.getItem('CompanyIdForUC');
    this.initializeForm();

    this.authService.getValidationMessage().subscribe(resp => {
      this.validationMessages = resp.loadChartForm;      
      this.genericValidator = new GenericValidator(this.validationMessages);
    });
  }

  ngOnInit() {
    this.ResizeHeight();
    this.GetSiteList(this.CompanyIdforUC);
    this.searchControl.valueChanges.subscribe((searchTerm: any) => {
      this.onSelectSiteSearch(searchTerm);
    });

     // Call service for validation on valu change
     this.loadChartForm.valueChanges.subscribe((value: any) => {
      this.displayMessage = this.genericValidator.processMessages(
        this.loadChartForm
      );
    });
  }
  initializeForm() {
    this.loadChartForm = this.formBuilder.group({
      SiteId: ['', [Validators.required]],
      PanelId: ['', [Validators.required]],
      DeviceId: ['', [Validators.required]],
      RegisterDataId: [''],
      FormStartDate: [new Date()],
      FormEndDate: [new Date()],
      FromTime: [''],
      ToTime: [''],
      DataType: ['RawData', [Validators.required]]
    });
  }
  //Called when window resize
  onResize() {
    this.ResizeHeight();
  }
  onSelectSiteSearch(searchTerm: any) {
    if (!searchTerm) {
      // Reset to original data if search term is empty
      this.ReportDetailList.data = this.dataSource;
    } else {
      // Filter data based on search term
      this.ReportDetailList.data = this.dataSource.filter((item: any) =>
        Object.values(item).some((value) =>
          value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )
      );
    }
  }
  //Called function on initial and window resize
  ResizeHeight() {
    this.windowheight = localStorage.getItem('WindowHeight');
    this.divHeight = this.windowheight - 160;
    this.tableHeight = this.divHeight - 90;
  }
  getLoadChartList() {
    let nameDevice = this.DeviceList.find(
      (device) => device.CodeValue == this.loadChartForm.value.DeviceId
    );

    //////////////////////////////////////
    if (!this.loadChartForm.value.FromTime) {
      this.loadChartForm.value.FromTime = '00:00'
    }
    if (!this.loadChartForm.value.ToTime) {
      this.loadChartForm.value.ToTime = '23:59'
    }
    const formatToHHMM = (time: any, fallback: string): string => {
      try {
        const dateObj = time instanceof Date ? time : new Date(time);
        if (!isNaN(dateObj.getTime())) {
          return formatDate(dateObj, 'HH:mm', 'en');
        }
      } catch { }
      return fallback;
    };
    let fromTimeValue = formatToHHMM(this.loadChartForm.value.FromTime, '00:01');
    let toTimeValue = formatToHHMM(this.loadChartForm.value.ToTime, '23:59');
    //////////////////////////////////////
    let req = {
      ReportName: 'Load Chart Report',
      MeterId: nameDevice.EnergymeterId,
      FromDate:
        [
          formatDate(
            this.loadChartForm.value.FormStartDate,
            'yyyy-MM-dd',
            'en'
          ),
        ][0] +
        ' ' +
        fromTimeValue,
      ToDate:
        [
          formatDate(
            this.loadChartForm.value.FormEndDate,
            'yyyy-MM-dd',
            'en'
          ),
        ][0] +
        ' ' +
        toTimeValue,
      companyCode: this.CompanyCode,
      IsforBatchData: this.IsforBatchData,
      // };
    };
    this.RegisterData.forEach(item => {
      item.MeterName = nameDevice.EnergymeterId;
    });
    var reqObj = {
      CurrentValue: true,
      FromDate:
        [
          formatDate(
            this.loadChartForm.value.FormStartDate,
            'yyyy-MM-dd',
            'en'
          ),
        ][0] +
        ' ' +
        fromTimeValue,
      ToDate:
        [
          formatDate(
            this.loadChartForm.value.FormEndDate,
            'yyyy-MM-dd',
            'en'
          ),
        ][0] +
        ' ' +
        toTimeValue,
      "companyCode": this.CompanyCode,
      "GraphConfigId": 0,
      "TimeInterval": "00:01",
      'DataType': "Current",// current,diff,avg,total for calculation
      'TimeType': 'Daily', // Daily,Hourly,Weekly,Monthly,Yearly for calculation
      "MainRegisterData": this.RegisterData,
      IsforBatchData: this.IsforBatchData,
    }
    this.flowmeterservice.GetCustomGraphData(reqObj).subscribe(
      (result) => {
        if (result?.ReportData?.length == 0) {
          this.errorMsg = 'No Records Found.';
        } else {
          this.errorMsg = '';
        }
        if (result) {
          this.ReportDetailList = new MatTableDataSource(result?.DescReportData);
          this.dataSource = result?.DescReportData;
          this.TagId_List = result?.TagList;
          this.decimalList = result?.DecimalPoint;
          this.ReportDetailList.paginator = this.paginator;
          this.ReportDetailList.sort = this.sort;
          // Assuming `this.labelname_List` is an object
          if (result?.header) {
            // Ensure Date and Time are present
            result.header.Str_RTC_Time = 'Time';
            result.header.Str_RTC = 'Date';

            // Convert object to an array of key-label pairs
            this.labelname_List = Object.entries(result.header).map(
              ([key, label]) => ({
                key,
                label,
                isDateTime: key === 'Str_RTC' || key === 'Str_RTC_Time',
              })
            );

            // Sort to ensure "Date" and "Time" come first
            this.labelname_List.sort((a, b) => {
              if (a.key == 'Str_RTC') return -1; // Date first
              if (a.key == 'Str_RTC_Time' && b.key !== 'Str_RTC') return -1; // Time second
              return 0; // Keep other columns in the same order
            });
          }
          this.columns = this.labelname_List.map((l: any) => l.key);
        }
      }
    )
  }
  getCols() {
    setTimeout(() => {
      return this.labelname_List.map((l: any) => l.key);
    }, 500);
  }
  formatValue(value: any, key: string): string {
    if (value == null || value === '') return ''; // Handle empty values
    const decimalPlaces = this.decimalList[key] ?? 2; // Default to 2 decimal places if key not found
    return parseFloat(value).toFixed(decimalPlaces);
  }

  // Function to extract Date from Str_RTC
  getDate(strRtc: string): string {
    return strRtc ? strRtc.split(' ')[0] : '';
  }

  // Function to extract Time from Str_RTC
  getTime(strRtc: string): string {
    return strRtc ? strRtc.split(' ')[1] : '';
  }

  // Called on change Panel
  OnChangePanel(event) {
    this.loadChartForm.patchValue({
      PanelId: event.value
    });

    this.PanelId = event.value;
    if (event.value == '') {
      this.DeviceList = []
    }
    this.GetEnergymeterList(this.SiteId, this.PanelId);

    this.loadChartForm.patchValue({
      DeviceId: ''
    });
  }

  // Get Register Data
  GetRegisterdata(id) {
    if (id != null) {
      this.GSMConfigService.GetRegisterdata(id, 'N', 'N', 'Y').subscribe(
        (result) => {
          if (result.listRegisterdata != null) {
            this.RegisterData = result.listRegisterdata;
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      )
    }
  }
  // Called on change Site
  OnChangeSite(event) {
    this.loadChartForm.patchValue({
      SiteId: event.value
    });

    this.SiteId = event.value;
    this.GetPanelList(event.value);
    // this.GetEnergymeterList(this.SiteId, 0);
    this.loadChartForm.patchValue({
      PanelId: '',
      DeviceId: ''
    });
    this.DeviceList = []
  }

  // Get Site List
  GetSiteList(CompanyId) {
    this.commonservice.GetSiteList(CompanyId).subscribe(
      (result) => {
        this.SiteList = result;
      },
      (error) => {
        this.errorMsg = error
      }
    )
  }

  // Get Panel List
  GetPanelList(SiteId) {
    this.commonservice.GetPanelList(SiteId).subscribe(
      (result) => {
        this.PanelList = result;
      },
      (error) => {
        this.errorMsg = error
      }
    )
  }

  // Get Energy meter List
  GetEnergymeterList(SiteId, PanelId) {
    this.commonservice.GetEnergyMeterIdList(SiteId, PanelId, 'Y').subscribe(
      (result) => {
        this.DeviceList = result;
      },
      (error) => {
        this.errorMsg = error
      }
    )
  }

  // Called on change Device
  OnChangeDeviceId(event) {
    this.loadChartForm.patchValue({
      DeviceId: event.value,
    });
    this.GetRegisterdata(event.value);
  }

  // Called on change Device
  OnChangeDataType(event) {
    if (event.value == 'BatchData') {
      this.IsforBatchData = 'Y';
    }
    else {
      this.IsforBatchData = 'N';
    }

  }

  onExport() {
    let deviceName = this.DeviceList.find(
      (device) => device.CodeValue == this.loadChartForm.value.DeviceId
    );
    let siteName = this.SiteList.find(
      (device) => device.CodeValue == this.loadChartForm.value.SiteId
    );
    let panelName = this.PanelList.find(
      (device) => device.CodeValue == this.loadChartForm.value.PanelId
    );
    //////////////////////////////////////
    if (!this.loadChartForm.value.FromTime) {
      this.loadChartForm.value.FromTime = '00:00'
    }
    if (!this.loadChartForm.value.ToTime) {
      this.loadChartForm.value.ToTime = '23:59'
    }
    const formatToHHMM = (time: any, fallback: string): string => {
      try {
        const dateObj = time instanceof Date ? time : new Date(time);
        if (!isNaN(dateObj.getTime())) {
          return formatDate(dateObj, 'HH:mm', 'en');
        }
      } catch { }
      return fallback;
    };
    let fromTimeValue = formatToHHMM(this.loadChartForm.value.FromTime, '00:01');
    let toTimeValue = formatToHHMM(this.loadChartForm.value.ToTime, '23:59');
    //////////////////////////////////////
    let req = {
      EnergymeterID: deviceName.EnergymeterId,
      SiteName: siteName.CodeDisplayText,
      PanelName: panelName.CodeDisplayText,
      FromDate:
        [
          formatDate(
            this.loadChartForm.value.FormStartDate,
            'yyyy-MM-dd',
            'en'
          ),
        ][0] +
        ' ' +
        fromTimeValue,
      ToDate:
        [
          formatDate(
            this.loadChartForm.value.FormEndDate,
            'yyyy-MM-dd',
            'en'
          ),
        ][0] +
        ' ' +
        toTimeValue,
      ReportType: 'LoadChart',
      username: localStorage.getItem('UserName'),
      ReportName: 'Load Chart Report',
      companyCode: this.CompanyCode,
      IsforBatchData: this.IsforBatchData,
      CurrentValue: true,
      "TimeInterval": "00:01",
      'DataType': "Current",// current,diff,avg,total for calculation
      'TimeType': 'Daily', // Daily,Hourly,Weekly,Monthly,Yearly for calculation
      "MainRegisterData": this.RegisterData,
      "GraphConfigId": 0,
      "MeterName": deviceName.CodeDisplayText
    };

    this.adminService.ExportLoadFlowReport(req).subscribe(
      (result) => {
        if (result && result.Response) {
          window.open(result.Response, '_blank', '');
        }
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  onScheduleReport() {    
    var reqparam = { ...this.loadChartForm.value };

    const dialogRef = this.dialog.open(LoadChartScheduleReportComponent, {
      width: '80%',
      height: '400px',
      disableClose: true      
    });
  }
}
